import { render } from "./TaxaFixa.vue?vue&type=template&id=5d9cd22e&scoped=true"
import script from "./TaxaFixa.vue?vue&type=script&lang=js"
export * from "./TaxaFixa.vue?vue&type=script&lang=js"

import "./TaxaFixa.vue?vue&type=style&index=0&id=5d9cd22e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9cd22e"]])

export default __exports__